import { Chip, Stack, TextField, Typography } from '@mui/material'
import { ChangeEvent, FC } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import {
  setTemplateNameErrorMessage,
  updateTemplateName,
} from 'src/state/ducks/templates/editTemplate/actions'
import { RootState } from 'src/state/store'

export const NameRow: FC = () => {
  const dispatch = useDispatch()
  const templateName = useSelector(
    (state: RootState) => state.templatesState.editTemplate.name,
    shallowEqual,
  )
  const templateNameErrorMessage = useSelector(
    (state: RootState) =>
      state.templatesState.editTemplate.templateNameErrorMessage,
    shallowEqual,
  )

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const templateName = e.target.value
    dispatch(updateTemplateName(templateName))
    dispatch(setTemplateNameErrorMessage(''))
  }

  return (
    <Stack spacing={1} sx={{ mx: 2 }}>
      <Stack spacing={1} direction="row" alignItems="center">
        <Typography variant="subtitle1">ひな形名</Typography>
        <Chip label="必須" variant="required" size="small" />
      </Stack>
      <TextField
        inputProps={{ 'aria-label': 'ひな形名' }}
        onChange={onChange}
        value={templateName}
        fullWidth
        size="small"
        error={!!templateNameErrorMessage}
      />
      {templateNameErrorMessage && (
        <Typography id="error-message" color="error" fontWeight="bold">
          {templateNameErrorMessage}
        </Typography>
      )}
    </Stack>
  )
}
